export function EmptyState({
    title,
    description = 'Check back later or try again.',
    icon: Icon,
    action = null,
    className = "",
}) {
    return (
        <div className={`col-span-full text-center py-20 px-4 ${className}`.trim()}>
            {Icon && (
                <div className="flex justify-center mb-2">
                    <Icon className="w-10 h-10 text-(--color-primary)" />
                </div>
            )}
            {title ? (
                <h2 className="font-semibold text-(--neutral-900) font-heading">
                    {title}
                </h2>
            ) : null}
            {description ? (
                <p className="text-(--neutral-800) font-body">{description}</p>
            ) : null}
            {action && <div className="flex justify-center">{action}</div>}
        </div>
    )
}